import { ElementType, PropsWithChildren } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface NoticeTitleProps extends PropsWithChildren {
  /**
   * The element to render as. Defaults to a paragraph, because notices appear
   * at arbitrary depths (cards, dialogs, form fields) where a heading would
   * land out of order in the document outline. Pass `as="h3"` (or whichever
   * level fits the surrounding page) where the notice really is a section.
   */
  as?: ElementType;
  className?: string;
}

export function NoticeTitle({
  as: Component = 'p',
  className,
  children,
}: NoticeTitleProps) {
  return <Component className={cn(css.title, className)}>{children}</Component>;
}
